
import unionBlack from '~/assets/images/main/icons/union-black.svg'
export default {
  name: 'Checkbox',
  props: ['label', 'fontSize', 'ischecked'],
  data() {
    return {
      isChecked: true,
      unionBlack,
    };
  },
  mounted() {
     this.isChecked = !this.ischecked
  },
  methods: {
    isChk() {
        this.isChecked = this.ischecked
    }
  },
};
